/* eslint-disable no-unused-vars */
import bodymovin from '~/lottie-web/build/player/lottie_html.min';
import isInViewport from '../utils/inViewport';

export default class LottieAnimation {
  constructor() {
    this.selector = '.c-lottie-animation';

    this.animations = {};
    this.animationsInViewport = [];
  }

  bootstrap() {
    // Add data id to lotties
    this.createIds();
    this.handleLotties();
  }

  /**
   * Create animation IDs
   */
  createIds() {
    const elements = document.querySelectorAll(
      `${this.selector}, ${this.onceSelector}`
    );

    if (!elements) {
      return;
    }

    for (const [ idx, element ] of elements.entries()) {
      element.dataset.id = `lottie-${idx}`;
    }
  }

  /**
   * Handle all lotties
   */
  handleLotties() {
    this.animations = this.loadAnimationsAndSettings(this.selector);

    this.animations.forEach(item => {
      const { animation, settings: { inViewport }} = item;

      // If should play in the viewport
      if (inViewport === 'true') {
        this.animationsInViewport.push(item);
      } else {
        // Play the animation if autoplay and viewport is not set
        animation.play();
      }
    });

    if (this.animationsInViewport.length === 0) {
      return;
    }

    window.addEventListener('scroll', this.handleLottiesOnScroll.bind(this));
    window.addEventListener('load', this.handleLottiesOnScroll.bind(this));
  }

  /**
   * Play animations that need to play only when in viewport
   */
  handleLottiesOnScroll() {
    this.animationsInViewport.forEach(({ animation, settings: { node }}) => {
      if (isInViewport(node) && node.dataset.played !== 'true') {
        animation.play();

        // eslint-disable-next-line no-param-reassign
        node.dataset.played = 'true';
      }
    });
  }

  /**
   * Create a config of animations
   */
  loadAnimationsAndSettings(selector) {
    const nodes = document.querySelectorAll(selector);

    if (nodes.length === 0) {
      return;
    }

    const animations = [];

    for (const element of nodes) {
      const { lottieSettings: options, animationSettings } = this.getLottieSettings(element);

      const lottieOptions = {
        ...options,
        renderer: 'svg',
        container: element,
      };

      animations.push({
        animation: bodymovin.loadAnimation(lottieOptions),
        settings: animationSettings,
      });
    }

    return animations;
  }

  // eslint-disable-next-line class-methods-use-this
  getLottieSettings(node) {
    if (!node) {
      return {};
    }

    const { json, autoplay, loop, inViewport } = node.dataset;
    const hasAutoplay = inViewport !== 'true' && autoplay === 'true';

    return {
      lottieSettings: {
        path: json,
        loop: loop === 'true',
        autoplay: Boolean(hasAutoplay),
      },
      animationSettings: {
        node,
        inViewport,
      },
    };
  }
}
